// src/features/services/media/hooks/mixEngine/rbLoader.ts

let _rbWasmCache: Promise<ArrayBuffer> | null = null;
let _rbLastFailAt = 0;
const RB_FAIL_BACKOFF_MS = 30_000; // 30s backoff after a failure

/**
 * Load Rubber Band WASM from local public assets.
 * Expects the file at: public/wasm/rubberband.wasm
 */
export function loadRbWasm(url: string = '/wasm/rubberband.wasm', signal?: AbortSignal): Promise<ArrayBuffer> {
  if (_rbWasmCache) return _rbWasmCache;

  if (_rbLastFailAt && Date.now() - _rbLastFailAt < RB_FAIL_BACKOFF_MS) {
    return Promise.reject(new Error('RB WASM load is in backoff period'));
  }

  _rbWasmCache = (async () => {
    try {
      const res = await fetch(url, { cache: 'force-cache', signal });
      if (!res.ok) {
        throw new Error(`Failed to fetch ${url}, status ${res.status}`);
      }
      const ab = await res.arrayBuffer();
      // Return a copy to avoid accidental retention by callers
      const out = ab.slice(0);
      return out;
    } catch (err) {
      _rbLastFailAt = Date.now();
      console.error('[rbLoader] Failed to load WASM:', err);
      throw err;
    }
  })();

  return _rbWasmCache;
}

/** Clear the memoized promise (useful during hot reload or swapping assets). */
export function resetRbWasmCache() {
  _rbWasmCache = null;
  _rbLastFailAt = 0;
}
